/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const locationSearchFilterSchema = z.object({
  activeOnly: z.boolean().nullish(),
  holidaySchemeIds: z.array(z.int()).nullish(),
});
